import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'trustUrl'
})
export class TrustUrlPipe implements PipeTransform {

  constructor(private sanitize: DomSanitizer) { }

  transform(url: string, type?: string): any {

    if (type == 'style-url') {
      return this.sanitize.bypassSecurityTrustStyle('url(' + url + ')');
    }
    else {
      return this.sanitize.bypassSecurityTrustUrl(url);
    }

  }

}
